import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SparaButton.module.scss';
import { LoaderSpinner } from '../Loader';

const SparaButton = ({
    children,
    onClick,
    variant = 'filled',
    color = 'primary',
    size = 'medium',
    disabled = false,
    loading = false,
    icon: IconComponent,
    className,
    style,
    ...rest
}) => {
    const isDisabled = disabled || loading;

    const buttonClasses = clsx(
        styles.button,
        styles[variant],
        styles[color],
        styles[size],
        { [styles.disabled]: isDisabled },
        { [styles.withIcon]: !!IconComponent },
        { [styles.loading]: loading },
        className
    );

    return (
        <button
            className={buttonClasses}
            onClick={!isDisabled ? onClick : undefined}
            disabled={isDisabled}
            style={style}
            {...rest}
        >
            {IconComponent && <IconComponent className={styles.icon} />}
            {children}
            {loading && (
                <span className={styles.spinnerSlot}>
                    <LoaderSpinner size={14} />
                </span>
            )}
        </button>
    );
};

SparaButton.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    variant: PropTypes.oneOf(['filled', 'outlined']),
    color: PropTypes.oneOf(['primary', 'secondary', 'warning', 'danger']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    icon: PropTypes.elementType,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default SparaButton;
